import React from 'react';
import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const contractsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'contracts',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/Contracts')),
});
